import { gql, useQuery } from '@apollo/client';

import type { AdminCurrentUserQuery, AdminCurrentUserQueryVariables } from './__generated__/useAdminCurrentUser.gql';

const ADMIN_CURRENT_USER = gql`
  query AdminCurrentUser {
    adminCurrentUser {
      id
      firstName
      lastName
      name
      email
      avatarUrl
      createdAt
    }
  }
`;

export type AdminCurrentUser = AdminCurrentUserQuery['adminCurrentUser'];

export const useAdminCurrentUser = () => {
  const { data, loading, error, refetch } = useQuery<AdminCurrentUserQuery, AdminCurrentUserQueryVariables>(
    ADMIN_CURRENT_USER,
    {
      fetchPolicy: 'cache-and-network',
    }
  );

  return { user: data?.adminCurrentUser ?? null, loading, error, refetch };
};
